<template>
  <div class="child-page-header"
       :class="pageHeaderStyles">
    <header-mobile-page v-if="$mq === 'mobile'"
                        class="mobile-header"
                        :label="child.name" />

    <div class="child-page-header-control child-page-header-item-margin-right">
      <profile-settings-card class="child-page-header-item-margin-right"
                             :child-id="childId"
                             :size="size" />

      <screen-time-card :child-id="childId"
                        :size="size"/>
    </div>

    <div class="child-page-header-control-column"
         :class="childSettingsStyles">
      <device-availability-card :child-id="childId"
                                :size="size" />

      <device-availability-label class="status-label"
                                 :child-id="childId" />

      <device-unrestricted-label class="status-label"
                                 :child-id="childId" />
    </div>
  </div>
</template>

<script>
  import ProfileSettingsCard from '@/components/Child/ChildPageHeader/ProfileSettingsCard.vue'
  import ScreenTimeCard from '@/components/Child/ChildScreenTime/ScreenTimeCard'
  import DeviceAvailabilityCard from '@/components/Child/ChildDeviceAvailability/DeviceAvailabilityCard'
  import DeviceAvailabilityLabel from '@/components/Child/ChildDeviceAvailability/DeviceAvailabilityLabel.vue'
  import DeviceUnrestrictedLabel from '@/components/Child/ChildDeviceAvailability/DeviceUnrestrictedLabel.vue'
  import HeaderMobilePage from '@/components/Header/HeaderMobilePage'

  import analytics from '@/services/analytics.js'

  export default {
    props: {
      childId: {
        required: true,
        type: String
      }
    },

    components: {
      ScreenTimeCard,
      DeviceAvailabilityCard,
      ProfileSettingsCard,
      DeviceAvailabilityLabel,
      DeviceUnrestrictedLabel,
      HeaderMobilePage
    },

    methods: {
      openProfileSettings() {
        analytics.sendEvent('Pk_EditCh_ChProf')

        if (!this.currentUser.hasPaidLicense) {
          return
        }

        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'children.single.childProfile',
            params: {
              childId: this.childId
            }
          })

          return
        }

        this.showModal('profile', {
          childId: this.childId
        })
      }
    },

    computed: {
      child() {
        return this.getChildById(this.childId)
      },

      size() {
        return this.$options.filters.mq(this.$mq, {
          small: 'small',
          medium: 'medium',
          big: 'big',
          mobile: 'mobile'
        })
      },

      primaryDevice() {
        return this.child.devices.find(device => device.id === this.child.primary_device_id)
      },

      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      ...mapGetters('auth', {
        currentUser: 'currentUser'
      }),

      pageHeaderStyles() {
        return {
          'child-page-header-mobile': this.$mq === 'mobile' || this.$mq === 'small'
        }
      },

      childSettingsStyles() {
        return {
          'child-settings-mobile': this.$mq === 'mobile'
        }
      },

      restrictionsMenuStyles() {
        return {
          'standard-restrictions-menu-mobile': this.$mq === 'mobile'
        }
      },

      noDeviceStyles() {
        return {
          'no-device-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .child-page-header {
    display: flex;
    flex: 0 0 126px;
    align-items: flex-start;

    padding: 30px 16px 18px;

    &-control {
      height: 75px;
      display: flex;
    }

    &-control-column {
      display: flex;
      flex-direction: column;
    }

    &-item-margin-right {
      margin-right: 16px;
    }

    .status-label {
      margin-top: 10px;
    }
  }

  .child-page-header-mobile {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;

    padding: 10px;

    .child-page-header-control {
      width: 100%;

      margin-bottom: 8px;
    }

    .child-page-header-control-column {
      width: 100%;
    }

    .child-page-header-item-margin-right {
      margin-right: 4px;
    }

    .mobile-header /deep/ {
      margin: 0;
      margin-bottom: 5px;
    }
  }
</style>
